import { FC } from "react";

import { t } from "i18n/i18n";

// View to show when there are no pages in a course.
export const NoPageView: FC = () => {
  return (
    <div className="flex h-full w-full justify-center text-black-tint-40">
      <div className="mt-[200px]">
        <div className="flex flex-col items-center gap-3">
          <div>{t("page_detail_view.no_content")}</div>
        </div>
      </div>
    </div>
  );
};
